import { AutocompleteRenderInputParams, TextField } from '@mui/material'
import { Fragment } from 'react/jsx-runtime'
import { useState } from 'react'
import sxInputRootGenerator from './sxInputRootGenerator'

/**
 * Suite à un retour du RANI (Réseau d'accessibilité) :
 *
 * Material-UI utilise un fieldset pour son style prédéfini,
 * mais il n'est parent d'aucun input :
 * son usage est donc illégitime et non accessible
 *
 * Donc on le supprime via le slot "notchedOutline" (voir le theme).
 *
 * Cependant, ce n'est pas suffisant, car cela casse la liste des options des Autocomplete
 * et on perd le style qui va avec.
 * Il est donc important de l'utiliser conjointement avec la fonction
 * "renderInputAccessibleGenerator" pour le props "renderInput" de chaque Autocomplete. */
export function renderInputAccessibleGenerator(label: string, dataCy?: string) {
  return function (params: AutocompleteRenderInputParams) {
    const [focused, setFocused] = useState(false)

    return (
      <TextField
        {...params}
        variant="outlined"
        label={label}
        margin="normal"
        color="secondary"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        slotProps={{
          root: {
            sx: sxInputRootGenerator(focused)
          },
          inputLabel: {
            ...params.slotProps.inputLabel,
            sx: { backgroundColor: 'white', px: 1, mx: -1 },
            'aria-label': `${label}. Les résultats sont affichés à la volée`
          },
          htmlInput: {
            ...params.slotProps.htmlInput
          },
          input: {
            ...params.slotProps.input,
            slots: {
              notchedOutline: Fragment
            }
          }
        }}
        data-cy={dataCy}
      />
    )
  }
}
